<div class="flex flex-col gap-4">
  <div class="flex items-center justify-between">
    <form class="flex flex-col gap-4" [formGroup]="form">
      <mat-slide-toggle color="primary" formControlName="testModeEnabled">
        Enable Test Mode
      </mat-slide-toggle>
    </form>
    <div class="max-w-[120px]">
      <img class="logo" src="/assets/integrations/tnz-logo.png" />
    </div>
  </div>

  <form
    *prIsManagement
    class="flex flex-col gap-4"
    [formGroup]="managementForm"
  >
    <span><strong>Sub-account: </strong>{{ orgSlug$ | async }}</span>

    <mat-slide-toggle color="primary" formControlName="enabled">
      Enable Integration
    </mat-slide-toggle>

    <pr-stripe-sms-pricing-selector
      [region]="region()"
      [selectedPrices]="data$ | async"
      (pricingChanged)="pricingUpdate.next($event)"
    />

    <button
      class="self-end"
      mat-flat-button
      color="primary"
      [disabled]="isDisabled$ | async"
      (click)="save()"
    >
      Save
    </button>
  </form>

  <pr-stripe-sms-pricing-selector
    readOnly
    [region]="region()"
    [selectedPrices]="data$ | async"
  />
</div>
